/**
 * Created by qlong on 10/3/2016.
 */

const initialState = {
    chart:{},
    shouldComponentUpdate: false,
}

export default function reducer(state=initialState,action) {
    switch (action.type) {
        case "ADD_CHART":
            return {...state, chart: action.payload}
        case "CHANGE_INDICATOR":
            return {...state, shouldComponentUpdate: action.payload}

    }
    return state
}


/** WEBPACK FOOTER **
 ** ./src/reducers/filteredLineChartReducer.js
 **/